import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { instituteInfo, allBlogs } from '../../Data/BlogData';
import '../../Component/blog.css';


const InstituteBlogs = () => {
  const { instituteId } = useParams();
  const info = instituteInfo[instituteId] || { name: 'Institute', location: 'Location', img: 'default.jpg' };

  // Filter only the blogs belonging to this specific institute
  const filteredBlogs = allBlogs.filter(blog => blog.instituteId === instituteId);

  return (
    <>
      <section className="Subpage_Hero">
        <div className="container">
          <div className="text-lg-start text-center">
            <h1>{info.name} Blogs</h1>
            <p>Latest updates and stories from {info.name}</p>
          </div>
          <nav aria-label="breadcrumb" className="breadcrumb-nav">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
              <li className="breadcrumb-item"><Link to="/Blog">Institutes</Link></li>
              <li className="breadcrumb-item active">{info.name}</li>
            </ol>
          </nav>
        </div>
      </section>

      <section className="institute-blogs-section">
        <div className="container">
          <div className="row">
            {filteredBlogs.length > 0 ? (
              filteredBlogs.map((blog) => (
                <div className="col-lg-6 col-md-6 mb-4" key={blog.id}>
                  <Link to={`/blog/${instituteId}/${blog.slug}`} className="blog-list-card">
                    <div className="d-flex">
                      <div className="blog-list-img">
                        <img src={`/assets/images/Courses/${blog.mainImage}`} alt={blog.title} />
                      </div>
                      <div className="blog-list-content">
                        <h5>{blog.title}</h5>
                        <span className="blog-date">{blog.date}</span>
                        <p>{blog.excerpt}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <p className="text-center">No blogs available for this institute yet.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default InstituteBlogs;